module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7r2r5r-94fbc1ca8c27bf4898e13aef7183b781.svg";